import angular from 'angular'

import Emitter from '../utils/emitter'

import { once, uniqueId, isString, conformsTo } from 'lodash-es'

angular
  .module('ggs.gallery-vote-frame')
  .factory('VoteFrame', VoteFrameProvider)

const DEFAULT_ATTEMPT_LIMIT = Infinity
const DEFAULT_ATTEMPT_DELAY = 60e3

function VoteFrameProvider(qh, Frame, DefineMethod, DefineHandler) {
  return function VoteFrame(
    iframeUrl,
    iframeParent,
    attemptLimit = DEFAULT_ATTEMPT_LIMIT,
    attemptDelay = DEFAULT_ATTEMPT_DELAY) {

    const sign = `voteFrame[uid=${uniqueId()}]`
    const frame = Frame(iframeUrl, iframeParent, attemptLimit, attemptDelay)
    const voteFrame = {
      sign,
      wrapM: DefineMethod(sign),
      wrapH: DefineHandler(sign),
      message: Emitter(sign)
    }

    voteFrame.wrapM('init', once(() => {
      frame.message.on(voteFrame.messageHandler)
      return frame.load()
    }))

    voteFrame.wrapM('destroy', once(() => {
      frame.message.off(voteFrame.messageHandler)
      return frame.destroy()
    }))

    voteFrame.wrapM('emit', qh.makeOver(voteFrame.init, (namespace, payload) => {
      return frame.send({ namespace, payload })
    }))

    voteFrame.wrapH('messageHandler', (msg) => {
      if (conformsTo(msg, { namespace: isString })) {
        voteFrame.message.emit(msg.namespace, msg.payload)
      }
    })

    return voteFrame
  }
}
